import { db, realtimeDB } from './firebase'
import { IUser, IWorkshop } from './types'
import { IActivityLockOptions } from './types/Activity'
import { genColor, genId } from './util'
import { collection, doc, getDoc, setDoc } from 'firebase/firestore'
import { get, ref, set } from 'firebase/database'

export const canUserEdit = (
  isFacilitator: boolean,
  locked: IActivityLockOptions | undefined,
  isOnStage: boolean,
) =>
  locked === 'locked'
    ? false
    : locked === 'facilitator'
    ? isFacilitator
    : locked === 'on_stage'
    ? isFacilitator || isOnStage
    : locked === 'create_only'
    ? Boolean('create_only') // shouldn't it be separate function?
    : true

export function createNewUser(initialData: Partial<IUser>): IUser {
  const newUser = {
    ...initialData,
    id: genId(),
    name: initialData.name || 'Guest',
    color: initialData.color || genColor(),
    authProvider: initialData.authProvider || 'anonymous',
  } as IUser

  return newUser
}

export function saveUserToDatabase(user: IUser) {
  if (!user.id) throw new Error('User id is required')
  return setDoc(doc(db, 'users', user.id), user)
}

const cache: { [id: IUser['id']]: Promise<IUser | null> } = {}

export function getUserById(id: string): Promise<IUser | null> {
  if (id in cache) {
    return cache[id]
  } else {
    // console.log('get user by id', id, doc(db, 'users', id))
    cache[id] = getDoc(doc(collection(db, 'users'), id))
      .then(doc => {
        if (!doc.exists) return null
        return doc.data() as IUser
      })
      .catch(() => {
        return null
      })
    return cache[id]
  }
}

export function loadUserFromLocalStorage(): IUser | null {
  const user = localStorage.getItem('user')
  if (!user) return null
  return JSON.parse(user)
}

export const addUserToWhitelist = async (workshopId: IWorkshop['id'], id: IUser['id']) => {
  if (!id) return
  if (!workshopId) throw new Error('Workshop id is required')
  const whiteListRef = ref(realtimeDB, `/workshop/${workshopId}/whiteList`)
  const whiteListSnapshot = await get(whiteListRef)
  const whiteList = whiteListSnapshot.val() || []
  if (!whiteList.includes(id)) {
    set(whiteListRef, whiteList.concat(id))
  }
}
